var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"common-dialog-container",class:{ tile: _vm.closePosition === 'tile' },style:({ backgroundColor: 'rgba(0, 0, 0, ' + _vm.maskOpacity + ')' }),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return (function () {
      _vm.closeOnClickModal && _vm.handleClose($event);
    }).apply(null, arguments)}}},[_c('div',{staticClass:"wrapper",class:{ tile: _vm.closePosition === 'tile', fixed: _vm.fixed },style:({ width: _vm.width })},[(_vm.showClose)?_c('a',{staticClass:"close-btn",class:{
        outside: _vm.closePosition === 'outside',
        inside: _vm.closePosition === 'inside',
        tile: _vm.closePosition === 'tile',
        'blank-fill__small': _vm.blankFill === 'small'
      },attrs:{"href":"javascript:;"},on:{"mousedown":_vm.handleCloseBefore,"click":_vm.handleClose}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dialog-root",class:{
        inside: _vm.closePosition === 'inside',
        tile: _vm.closePosition === 'tile',
        'blank-fill__small': _vm.blankFill === 'small'
      }},[(_vm.closePosition === 'inside' && (_vm.$slots.header || _vm.title))?_c('div',{staticClass:"dialog-header",class:{
          'blank-fill__small': _vm.blankFill === 'small'
        }},[(_vm.$slots.header)?[_vm._t("header")]:_vm._e(),_vm._v(" "),(_vm.title)?[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.$slots.body)?_c('div',{staticClass:"dialog-body",class:{
          outside: _vm.closePosition === 'outside',
          'blank-fill__small': _vm.blankFill === 'small'
        }},[_vm._t("body")],2):_vm._e(),_vm._v(" "),(
          (_vm.closePosition === 'inside' || _vm.closePosition === 'tile') &&
            _vm.$slots.footer
        )?_c('div',{staticClass:"dialog-footer",class:{
          'blank-fill__small': _vm.blankFill === 'small'
        },style:(_vm.footerStyle)},[_vm._t("footer")],2):_vm._e()])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b8f35fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonDialog/index.vue
// module id = null
// module chunks = 